/* src/app/components/analytics/case-analytics/items/case-analytics-collection-summary/case-analytics-collection-summary.component.scss */
.card-header-skeleton-loader {
  height: 63.6px;
  margin: 5px;
}
[card-header-content-primary],
[card-header-no-content] {
  height: 73.6px;
  overflow: hidden;
}
[card-header-content-primary] div,
[card-header-no-content] div {
  flex-grow: 1;
  flex-basis: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  transition: font-size 200ms ease-in;
}
[card-header-content-primary]:has(div:nth-child(3)) div:nth-child(1),
[card-header-no-content]:has(div:nth-child(3)) div:nth-child(1) {
  font-size: 1.6rem;
}
[card-header-content-primary]:has(div:nth-child(3)) div:nth-child(2),
[card-header-no-content]:has(div:nth-child(3)) div:nth-child(2) {
  font-size: 2.1rem;
  font-weight: 500;
}
[card-header-content-primary]:has(div:nth-child(3)) div:nth-child(3),
[card-header-no-content]:has(div:nth-child(3)) div:nth-child(3) {
  font-size: 1rem;
  color: #4F4F4F;
}
:host-context(.dark-theme) [card-header-content-primary]:has(div:nth-child(3)) div:nth-child(3),
:host-context(.dark-theme) [card-header-no-content]:has(div:nth-child(3)) div:nth-child(3) {
  color: #dbdbdb;
}
[card-header-content-primary]:not(:has(div:nth-child(3))),
[card-header-no-content]:not(:has(div:nth-child(3))) {
  height: 73.6px;
  max-height: 73.6px;
}
[card-header-content-primary]:not(:has(div:nth-child(3))) div:nth-child(1),
[card-header-no-content]:not(:has(div:nth-child(3))) div:nth-child(1) {
  font-size: 1.6rem;
  display: flex;
  flex-direction: column;
}
[card-header-content-primary]:not(:has(div:nth-child(3))) div:nth-child(1):before,
[card-header-no-content]:not(:has(div:nth-child(3))) div:nth-child(1):before {
  content: "(";
  position: relative;
  -webkit-user-select: none;
  user-select: none;
  visibility: hidden;
  cursor: none;
  opacity: 0;
  font-size: 1rem;
  font-weight: 500;
}
[card-header-content-primary]:not(:has(div:nth-child(3))) div:nth-child(2),
[card-header-no-content]:not(:has(div:nth-child(3))) div:nth-child(2) {
  font-size: 1rem;
  margin-top: 0.5rem;
  color: #4F4F4F;
}
:host-context(.dark-theme) [card-header-content-primary]:not(:has(div:nth-child(3))) div:nth-child(2),
:host-context(.dark-theme) [card-header-no-content]:not(:has(div:nth-child(3))) div:nth-child(2) {
  color: #dbdbdb;
}
[card-header-content-primary]:not(:has(div:nth-child(3))) div:nth-child(2) b:after,
[card-header-no-content]:not(:has(div:nth-child(3))) div:nth-child(2) b:after {
  content: ")";
  position: relative;
  display: flex;
  flex-direction: column;
  -webkit-user-select: none;
  user-select: none;
  visibility: hidden;
  cursor: none;
  opacity: 0;
  font-size: 0.1rem;
  font-weight: 500;
}
.card-body-content {
  position: relative;
}
[card-body-content-chart] {
  position: absolute;
  width: 100%;
  height: var(--height, calc(100% - 12px));
  display: flex;
  justify-content: center;
  transition: 200ms linear opacity;
  background-color: var(--background-card);
}
[card-body-content-chart].loading-display {
  height: initial;
  padding-bottom: 4vh;
  margin-top: auto;
}
[card-body-content-chart].loading {
  opacity: 0;
}
.loading-legend {
  display: inline-flex;
  gap: 20px;
  margin: 20px 0;
}
[card-body-loading-icon] {
  color: #a4a4a4;
}
.loading-chart [card-body-loading-icon] {
  font-size: 180px;
}
.loading-legend [card-body-loading-icon] {
  font-size: 18px;
}
[card-body-loading-icon].fa-fade {
  animation-delay: 0s;
  animation-direction: normal;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
}
[card-body-no-content] {
  --primary-theme-color: var(--palette-primary-default, #243e90cc);
}
:host-context(.dark-theme) [card-body-no-content] {
  --primary-theme-color: var(--palette-accent-default, #ffc105cc);
}
[card-body-no-content] {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-bottom: 20px;
}
[card-body-no-content] .container {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 20px;
}
[card-body-no-content] .icon {
  color: var(--primary-theme-color);
  font-size: 24px;
  font-weight: 500;
}
[card-body-no-content] .primary-text {
  color: var(--primary-theme-color);
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 2px;
}
[card-body-no-content] .secondary-text {
  color: var(--primary-theme-color);
  font-size: 13px;
}
:host-context(.dark-theme) [card-body-no-content] .secondary-text {
  color: #dbdbdb;
}
[card-body-content-legend] {
  color: #dbdbdb;
}
:host-context(.dark-theme) .skeleton-loader-dark-theme {
  --background-color-1: rgb(70 71 72);
  --foreground-color-1: rgb(90 91 92);
  --foreground-color-2: rgb(80, 81, 82);
  --grid-line-color: rgb(90, 91, 92);
  --shimmer-gradient:
    linear-gradient(
      
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.02) 20%,
      rgba(120,121,122, 0.9) 60%,
      rgba(255, 255, 255, 0) );
}
[card-body-no-content] {
  display: flex;
  flex-direction: column;
}
[card-body-no-content] button {
  background-color: var(--primary-theme-color, rgba(36, 62, 144, 0.8));
  color: white;
  font-weight: 400;
  height: 40px;
  word-spacing: -0.1px;
  padding: 0;
}
[body-subject] {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  word-spacing: -0.1px;
  font-size: 12px;
  color: rgb(225, 240, 255);
  justify-content: space-around;
  gap: 0px;
}
[body-subject] div {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
[body-subject] div:first-child {
  width: 25%;
  padding-right: 8px;
  padding-left: 8px;
}
[body-subject] div:last-child {
  width: 75%;
  padding-right: 8px;
  padding-left: 8px;
  border-left: 1px solid rgba(225, 240, 255, 0.5);
}
[body-subject] b {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 500;
  font-size: 14px;
  word-spacing: -0.2px;
  color: rgb(225, 240, 255);
}
[body-subject] i {
  width: 100%;
  height: 100%;
}
[card-body-no-content] button:before {
  content: "";
  opacity: 0.05;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: transparent;
}
[card-body-no-content] button:hover:before {
  content: "";
  opacity: 0.1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #000000;
}
.no-data-button {
  background-color: var(--primary-theme-color);
  color: #fff;
}
.no-data-button:hover::before {
  background-color: black;
}
:host-context(.dark-theme) .no-data-button {
  background-color: #000;
  color: var(--primary-theme-color);
}
:host-context(.dark-theme) .no-data-button:hover::before {
  background-color: white;
}
.pointerOnHover {
  cursor: pointer !important;
}
/*# sourceMappingURL=case-analytics-collection-summary.component.css.map */
